var Component = require("!../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-1e30f3ab!../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./dashboard.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/editor/src/modules/list/dashboard.vue
// module id = 546
// module chunks = 0